import styles from './css/healthmonitoringbars.module.css';
import Gradientbar from "./gradientbar"

export default function Healthmonitoringbars(props) {
    var wall = (props.damage && typeof props.damage.wall !== 'undefined') ? props.damage.wall.value : null;
    var partition = (props.damage && typeof props.damage.partition !== 'undefined') ? props.damage.wall.value : null;
    var ceiling = (props.damage && typeof props.damage.ceiling !== 'undefined') ? props.damage.ceiling.value: null;
    var equipment = (props.damage && typeof props.damage.equipment  !== 'undefined') ? props.damage.equipment.value: null;
    return (
        <div className={styles.container}>
            <div className={styles.item_right}>外装</div><div><Gradientbar value={wall} min={0} max={1.5}/></div>
            <div className={styles.item_right}>壁　</div><div><Gradientbar value={partition} min={0} max={1.5}/></div>
            <div className={styles.item_right}>天井</div><div><Gradientbar value={ceiling} min={0} max={1.5}/></div>
            <div className={styles.item_right}>設備</div><div><Gradientbar value={equipment} min={0} max={1.5}/></div>
        </div>
    )
}
